var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCertification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2169_4986)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 13,
    width: 27,
    height: 18,
    fill: "#6299FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.5 31V13L13 22L-0.5 31Z",
    fill: "#8DB5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 31V13L13 22L26.5 31Z",
    fill: "#8DB5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2707 23.0527L-0.5 13H26.5L15.7293 23.0527C14.1924 24.4871 11.8076 24.487 10.2707 23.0527Z",
    fill: "#C3D8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 0.5,
    width: 25,
    height: 35,
    rx: 3.5,
    fill: "#F3F3F3",
    stroke: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8711 7.65467L30.7187 5.85938L26.5016 7.65467V9.73646C26.5016 10.9397 26.3981 12.2002 27.8427 14.1101C28.6054 15.1185 30.0778 15.7272 30.7187 15.9054C31.2034 15.8417 32.4443 15.3936 33.5301 14.1101C34.8711 12.5249 34.8765 10.6596 34.8711 9.73646V7.65467Z",
    fill: "#00C968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0117 11.1665L30.1279 12.4688L32.5464 9.49219",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 18,
    width: 18,
    height: 1.5,
    rx: 0.75,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 21.5,
    width: 18,
    height: 1.5,
    rx: 0.75,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 25,
    width: 18,
    height: 1.5,
    rx: 0.75,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 28.5,
    width: 13,
    height: 1.5,
    rx: 0.75,
    fill: "#CACACA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2169_4986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCertification);
export default __webpack_public_path__ + "static/media/IcCertification.1771006272660c8e54b232651d7879f0.svg";
export { ForwardRef as ReactComponent };